export default __webpack_public_path__ + "static/media/portoIcon.78f78ccf.svg";